import Vue from 'vue'
import {
  RESET_STATE,
  SET_TABS_COLOR,
  IS_ROUTER_CHANGE,
  PUT_ACTIVITY_LOG_VERSION,
  PUT_DEVICE_EVENTS_VERSION,
} from '@/store/mutation-types'

let initialState = {
  headerColor: 'light',
  contentColor: 'light',
  isRouteChange: false,
  activityLogVersion: null,
  deviceEventsVersion: null,
  iceEventsVersion: null,
}

// initial state
const state = Vue.util.extend({}, initialState)

// getters
const getters = {
  tabsHeaderColor: function (state) {
    return state.headerColor
  },
  tabsContentColor: function (state) {
    return state.contentColor
  },
  isRouteChange: function (state) {
    return state.isRouteChange
  },
  activityLogVersion: function (state) {
    return state.activityLogVersion || '2'
  },
  deviceEventsVersion: function (state) {
    return state.deviceEventsVersion || '2'
  },
}

// actions
const actions = {
}

// mutations
const mutations = {
  [RESET_STATE]: function (state) {
    for (let f in state) {
      Vue.set(state, f, initialState[f])
    }
  },
  [SET_TABS_COLOR]: function (state, {headerColor, contentColor}) {
    state.headerColor = headerColor
    state.contentColor = contentColor
  },
  [IS_ROUTER_CHANGE]: function (state, status) {
    state.isRouteChange = status
  },
  [PUT_ACTIVITY_LOG_VERSION]: function (state, version) {
    Vue.set(state, 'activityLogVersion', version)
  },
  [PUT_DEVICE_EVENTS_VERSION]: function (state, version) {
    Vue.set(state, 'deviceEventsVersion', version)
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
